import { render, staticRenderFns } from "./ques-blank.vue?vue&type=template&id=3cca12af&scoped=true"
import script from "./ques-blank.vue?vue&type=script&lang=js"
export * from "./ques-blank.vue?vue&type=script&lang=js"
import style0 from "./ques-blank.vue?vue&type=style&index=0&id=3cca12af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca12af",
  null
  
)

export default component.exports